import { tViews } from "../../../../../utils/table";

export default {
  get title() { return tViews('dashletSiteViewSites'); },
  get subTitle() { return tViews('dashletSiteViewSites'); },
  get siteLegend() {
    return {
      theme: "overlay",
      labels: [
        tViews('applicationCircuitViewLabelAvailable'),
        tViews('applicationCircuitViewLabelPrevious'),
        tViews('applicationOverviewTotal')
      ]
    };
  },
  columns: [
    {
      get title() { return tViews('site'); },
      colSpan: 1,
      property: "site_name",
      type: "string",
      format: "link",
      maxLength: 15,
      width: "20%"
    },
    {
      get title() { return tViews('dashletSiteViewAvailabilityPerValue'); },
      colSpan: 1,
      property: "up_percent",
      type: "number",
      format: "percent",
      theme: "changeQuality",
      tooltip: true,
      get tooltipTitle() { return String(tViews('siteTableAvailBarChart') || ''); },
      get tooltipDefinition() { return String(tViews('siteTableAvailBarChartDefinition') || ''); },
      width: "20%",
      padding: "0px"
    },
    {
      get title() { return tViews('siteViewLocation'); },
      colSpan: 1,
      property: "city",
      type: "string",
      format: "link",
      maxLength: 20,
      padding: "2px"
    },
    {
      get title() { return tViews('sitesViewTotalTime'); },
      colSpan: 1,
      property: "chart",
      type: "chart",
      format: "overlayBarChart",
      padding: "0px",
      width: "30%",
      maxLength: 10,
      tooltipEllipse: true
    }
  ]
};
